import { debounce } from 'lodash';
import toaster from '../shared/toaster';

import { ExceptionTypes } from '../shared/types';
import { SystemErrors } from '../shared/enums/system-errors';

// eslint-disable-next-line import/no-cycle
import { triggerSessionExpiration } from '../shared/utils';
import { showValidationErrorNotification } from '../shared/utils/errors';
import { planError } from '../shared/utils/errors/plan-permission-error/plan-error';

const debounceErrorToaster = debounce((errorMessage: string) => {
  toaster.error(errorMessage);
}, 500);

const handleSystemError = (errorMessage?: string) => {
  debounceErrorToaster(errorMessage || SystemErrors.InternalServerError);
};

export const handleErrorByType = (data: any): boolean => {
  switch (data.type) {
    case ExceptionTypes.Auth:
      triggerSessionExpiration();
      return false;

    case ExceptionTypes.System:
      handleSystemError();
      return true;

    case ExceptionTypes.Validation:
      showValidationErrorNotification(data.messages);
      return true;

    case ExceptionTypes.PlanPermission:
      planError(data.code, data.message);
      return true;

    case ExceptionTypes.General:
    case ExceptionTypes.RateLimit:
      handleSystemError(data.message);
      return true;

    case ExceptionTypes.Silent:
      return true;

    default:
      handleSystemError();
      return true;
  }
};

/**
 * Handles API errors by displaying an error message using the toaster.
 * If the error has not already been handled (isErrorHandled is false),
 * it will show the error message from the API response or a default internal server error message.
 *
 * @param error - The error object returned from the API call.
 */
export function handleApiError(error: any): void {
  const message =
    error?.data && !error.data.isErrorHandled
      ? error.data.message || SystemErrors.InternalServerError
      : null;

  if (message) {
    toaster.error(message);
  }
}
